import './style.css';
import tmpl from './main.ejs';

class AdPause {
    constructor(opt) {
        this.opt = opt;
        this.init(opt);
    }

    init(opt) {
        this.initLayout(opt);
    }

    initLayout({ data }) {
        this.data = data;
        const adpause = {};
        adpause.img = data.pause_Url[0] || data.pause_Url[1];
        // adpause.img = data.test[0];
        if (adpause.img == undefined) {
            this.type = 'off';
            return false;
        }
        this.el = $(tmpl(adpause));
        this.item = this.el.find('.c-adPause__item');
        this.close = this.el.find('.c-adPause__close');

        // this.changeImg(0);
    }

    changeImg(type) {
        let img = this.data.pause_Url[type];
        this.item.css('background-image', `url(${img})`);
    }

    hide() {
        this.el.hide();
    }

    show() {
        this.el.show();
    }

    renderTo(parentNode) {
        $(parentNode).append(this.el);
    }
}

export default AdPause;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdPause/index.js